// Auto-generated by /app/scripts/build_i18n.py
export const LESSON_CODE = {
 "naive-string-match": {
  "c": {
   "code": "#include <stdlib.h>\n#include <string.h>\n\n/* Returns a malloc'd array of match indices; its length is stored in *returnSize. Caller must free. */\nint* naiveMatch(const char* text, const char* pattern, int* returnSize) {\n    int capacity = 4;\n    int* result = (int*)malloc(capacity * sizeof(int));\n    *returnSize = 0;\n    int n = (int)strlen(text), m = (int)strlen(pattern);\n    \n    for (int i = 0; i <= n - m; i++) {\n        int j = 0;\n        while (j < m && text[i + j] == pattern[j]) {\n            j++;\n        }\n        if (j == m) {\n            if (*returnSize == capacity) {\n                capacity *= 2;\n                result = (int*)realloc(result, capacity * sizeof(int));\n            }\n            result[(*returnSize)++] = i;\n        }\n    }\n    \n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    2,
    3,
    3,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    14,
    15,
    16,
    17
   ]
  },
  "cpp": {
   "code": "#include <string>\n#include <vector>\n\nclass Solution {\npublic:\n    std::vector<int> naiveMatch(const std::string& text, const std::string& pattern) {\n        std::vector<int> result;\n        int n = (int)text.length(), m = (int)pattern.length();\n        \n        for (int i = 0; i <= n - m; i++) {\n            int j = 0;\n            while (j < m && text[i + j] == pattern[j]) {\n                j++;\n            }\n            if (j == m) {\n                result.push_back(i);\n            }\n        }\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18
   ]
  },
  "python": {
   "code": "from typing import List\n\n\nclass Solution:\n    def naiveMatch(self, text: str, pattern: str) -> List[int]:\n        result = []\n        n, m = len(text), len(pattern)\n        \n        for i in range(n - m + 1):\n            j = 0\n            while j < m and text[i + j] == pattern[j]:\n                j += 1\n            if j == m:\n                result.append(i)\n        \n        return result",
   "map": [
    null,
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    11,
    12,
    15,
    16
   ]
  }
 },
 "merge-sort": {
  "c": {
   "code": "#include <stdlib.h>\n\nvoid mergeSortHelper(int* nums, int left, int right);\nvoid merge(int* nums, int left, int mid, int right);\n\nint* mergeSort(int* nums, int numsSize) {\n    mergeSortHelper(nums, 0, numsSize - 1);\n    return nums;\n}\n\nvoid mergeSortHelper(int* nums, int left, int right) {\n    if (left < right) {\n        int mid = left + (right - left) / 2;\n        mergeSortHelper(nums, left, mid);\n        mergeSortHelper(nums, mid + 1, right);\n        merge(nums, left, mid, right);\n    }\n}\n\nvoid merge(int* nums, int left, int mid, int right) {\n    int tempLength = right - left + 1;\n    int* temp = (int*)malloc(tempLength * sizeof(int));\n    int i = left, j = mid + 1, k = 0;\n    \n    while (i <= mid && j <= right) {\n        if (nums[i] <= nums[j]) {\n            temp[k++] = nums[i++];\n        } else {\n            temp[k++] = nums[j++];\n        }\n    }\n    \n    while (i <= mid) temp[k++] = nums[i++];\n    while (j <= right) temp[k++] = nums[j++];\n    \n    for (int m = 0; m < tempLength; m++) {\n        nums[left + m] = temp[m];\n    }\n    free(temp);\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    34
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> mergeSort(vector<int> nums) {\n        mergeSortHelper(nums, 0, (int)nums.size() - 1);\n        return nums;\n    }\n    \n    void mergeSortHelper(vector<int>& nums, int left, int right) {\n        if (left < right) {\n            int mid = left + (right - left) / 2;\n            mergeSortHelper(nums, left, mid);\n            mergeSortHelper(nums, mid + 1, right);\n            merge(nums, left, mid, right);\n        }\n    }\n    \n    void merge(vector<int>& nums, int left, int mid, int right) {\n        vector<int> temp(right - left + 1);\n        int i = left, j = mid + 1, k = 0;\n        \n        while (i <= mid && j <= right) {\n            if (nums[i] <= nums[j]) {\n                temp[k++] = nums[i++];\n            } else {\n                temp[k++] = nums[j++];\n            }\n        }\n        \n        while (i <= mid) temp[k++] = nums[i++];\n        while (j <= right) temp[k++] = nums[j++];\n        \n        for (int m = 0; m < (int)temp.size(); m++) {\n            nums[left + m] = temp[m];\n        }\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35
   ]
  },
  "python": {
   "code": "class Solution:\n    def mergeSort(self, nums):\n        self.mergeSortHelper(nums, 0, len(nums) - 1)\n        return nums\n    \n    def mergeSortHelper(self, nums, left, right):\n        if left < right:\n            mid = left + (right - left) // 2\n            self.mergeSortHelper(nums, left, mid)\n            self.mergeSortHelper(nums, mid + 1, right)\n            self.merge(nums, left, mid, right)\n    \n    def merge(self, nums, left, mid, right):\n        temp = [0] * (right - left + 1)\n        i, j, k = left, mid + 1, 0\n        \n        while i <= mid and j <= right:\n            if nums[i] <= nums[j]:\n                temp[k] = nums[i]\n                k += 1\n                i += 1\n            else:\n                temp[k] = nums[j]\n                k += 1\n                j += 1\n        \n        while i <= mid:\n            temp[k] = nums[i]\n            k += 1\n            i += 1\n        while j <= right:\n            temp[k] = nums[j]\n            k += 1\n            j += 1\n        \n        for m in range(len(temp)):\n            nums[left + m] = temp[m]",
   "map": [
    1,
    2,
    3,
    4,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    22,
    22,
    23,
    24,
    24,
    24,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    31,
    32
   ]
  }
 },
 "quick-sort": {
  "c": {
   "code": "#include <stddef.h>\n\nvoid quickSortHelper(int* nums, int low, int high);\nint partition(int* nums, int low, int high);\n\nint* quickSort(int* nums, int numsSize) {\n    quickSortHelper(nums, 0, numsSize - 1);\n    return nums;\n}\n\nvoid quickSortHelper(int* nums, int low, int high) {\n    if (low < high) {\n        int pivotIndex = partition(nums, low, high);\n        quickSortHelper(nums, low, pivotIndex - 1);\n        quickSortHelper(nums, pivotIndex + 1, high);\n    }\n}\n\nint partition(int* nums, int low, int high) {\n    int pivot = nums[high];\n    int i = low - 1;\n\n    for (int j = low; j < high; j++) {\n        if (nums[j] <= pivot) {\n            i++;\n            int temp = nums[i];\n            nums[i] = nums[j];\n            nums[j] = temp;\n        }\n    }\n\n    int temp = nums[i + 1];\n    nums[i + 1] = nums[high];\n    nums[high] = temp;\n\n    return i + 1;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> quickSort(vector<int>& nums) {\n        quickSortHelper(nums, 0, (int)nums.size() - 1);\n        return nums;\n    }\n    \n    void quickSortHelper(vector<int>& nums, int low, int high) {\n        if (low < high) {\n            int pivotIndex = partition(nums, low, high);\n            quickSortHelper(nums, low, pivotIndex - 1);\n            quickSortHelper(nums, pivotIndex + 1, high);\n        }\n    }\n    \n    int partition(vector<int>& nums, int low, int high) {\n        int pivot = nums[high];\n        int i = low - 1;\n        \n        for (int j = low; j < high; j++) {\n            if (nums[j] <= pivot) {\n                i++;\n                int temp = nums[i];\n                nums[i] = nums[j];\n                nums[j] = temp;\n            }\n        }\n        \n        int temp = nums[i + 1];\n        nums[i + 1] = nums[high];\n        nums[high] = temp;\n        \n        return i + 1;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34
   ]
  },
  "python": {
   "code": "class Solution:\n    def quickSort(self, nums):\n        self.quickSortHelper(nums, 0, len(nums) - 1)\n        return nums\n\n    def quickSortHelper(self, nums, low, high):\n        if low < high:\n            pivotIndex = self.partition(nums, low, high)\n            self.quickSortHelper(nums, low, pivotIndex - 1)\n            self.quickSortHelper(nums, pivotIndex + 1, high)\n\n    def partition(self, nums, low, high):\n        pivot = nums[high]\n        i = low - 1\n\n        for j in range(low, high):\n            if nums[j] <= pivot:\n                i += 1\n                temp = nums[i]\n                nums[i] = nums[j]\n                nums[j] = temp\n\n        temp = nums[i + 1]\n        nums[i + 1] = nums[high]\n        nums[high] = temp\n\n        return i + 1",
   "map": [
    1,
    2,
    3,
    4,
    6,
    7,
    8,
    9,
    10,
    11,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    27,
    28,
    29,
    30,
    31,
    32
   ]
  }
 },
 "dijkstra": {
  "c": {
   "code": "#include <stdlib.h>\n#include <limits.h>\n#include <stdbool.h>\n\nint* dijkstra(int** graph, int graphSize, int start) {\n    int n = graphSize;\n    int* dist = (int*)malloc(n * sizeof(int));\n    for (int i = 0; i < n; i++) dist[i] = INT_MAX;\n    dist[start] = 0;\n    bool* visited = (bool*)calloc(n, sizeof(bool));\n    \n    for (int i = 0; i < n; i++) {\n        // Pick unvisited node with min distance\n        int u = -1;\n        for (int v = 0; v < n; v++) {\n            if (!visited[v] && (u == -1 || dist[v] < dist[u])) u = v;\n        }\n        if (dist[u] == INT_MAX) break;\n        visited[u] = true;\n        \n        // Relax neighbors\n        for (int v = 0; v < n; v++) {\n            if (graph[u][v] > 0 && !visited[v]) {\n                int newDist = dist[u] + graph[u][v];\n                if (newDist < dist[v]) dist[v] = newDist;\n            }\n        }\n    }\n    \n    free(visited);\n    return dist;\n}",
   "map": [
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    null,
    27,
    28
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <climits>\n#include <algorithm>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> dijkstra(vector<vector<int>>& graph, int start) {\n        int n = graph.size();\n        vector<int> dist(n);\n        fill(dist.begin(), dist.end(), INT_MAX);\n        dist[start] = 0;\n        vector<bool> visited(n, false);\n        \n        for (int i = 0; i < n; i++) {\n            // Pick unvisited node with min distance\n            int u = -1;\n            for (int v = 0; v < n; v++) {\n                if (!visited[v] && (u == -1 || dist[v] < dist[u])) u = v;\n            }\n            if (dist[u] == INT_MAX) break;\n            visited[u] = true;\n            \n            // Relax neighbors\n            for (int v = 0; v < n; v++) {\n                if (graph[u][v] > 0 && !visited[v]) {\n                    int newDist = dist[u] + graph[u][v];\n                    if (newDist < dist[v]) dist[v] = newDist;\n                }\n            }\n        }\n        \n        return dist;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29
   ]
  },
  "python": {
   "code": "INT_MAX = 2147483647\n\nclass Solution:\n    def dijkstra(self, graph, start):\n        n = len(graph)\n        dist = [0] * n\n        dist[:] = [INT_MAX] * n\n        dist[start] = 0\n        visited = [False] * n\n        \n        for i in range(n):\n            # Pick unvisited node with min distance\n            u = -1\n            for v in range(n):\n                if not visited[v] and (u == -1 or dist[v] < dist[u]): u = v\n            if dist[u] == INT_MAX: break\n            visited[u] = True\n            \n            # Relax neighbors\n            for v in range(n):\n                if graph[u][v] > 0 and not visited[v]:\n                    newDist = dist[u] + graph[u][v]\n                    if newDist < dist[v]: dist[v] = newDist\n        \n        return dist",
   "map": [
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    26,
    27
   ]
  }
 },
 "n-queens": {
  "c": {
   "code": "#include <stdio.h>\n#include <stdlib.h>\n#include <string.h>\n#include <stdbool.h>\n\n/* class Solution */\nchar ***result = NULL;\nint resultSize = 0;\nint resultCap = 0;\nint **board;\nint n;\n\nvoid solve(int row);\nbool isSafe(int row, int col);\n\nchar **buildBoard(void) {\n    char **rows = (char **)malloc(n * sizeof(char *));\n    for (int i = 0; i < n; i++) {\n        rows[i] = (char *)malloc(n + 1);\n        for (int j = 0; j < n; j++) rows[i][j] = board[i][j] ? 'Q' : '.';\n        rows[i][n] = '\\0';\n    }\n    return rows;\n}\n\nchar ***solveNQueens(int n_arg, int *returnSize) {\n    n = n_arg;\n    board = (int **)malloc(n * sizeof(int *));\n    for (int i = 0; i < n; i++) board[i] = (int *)calloc(n, sizeof(int));\n    solve(0);\n    *returnSize = resultSize;\n    return result;\n}\n\nvoid solve(int row) {\n    if (row == n) {\n        if (resultSize == resultCap) {\n            resultCap = resultCap ? resultCap * 2 : 16;\n            result = (char ***)realloc(result, resultCap * sizeof(char **));\n        }\n        result[resultSize++] = buildBoard();\n        return;\n    }\n    \n    for (int col = 0; col < n; col++) {\n        if (isSafe(row, col)) {\n            board[row][col] = 1;\n            solve(row + 1);\n            board[row][col] = 0;  // backtrack\n        }\n    }\n}\n\nbool isSafe(int row, int col) {\n    // check column, diagonals\n    return true;  // full logic in visualization\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    1,
    2,
    2,
    2,
    3,
    4,
    5,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    6,
    7,
    8,
    8,
    9,
    10,
    10,
    11,
    12,
    13,
    14,
    15,
    15,
    15,
    15,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <string>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<vector<string>> result;\n    vector<vector<int>> board;\n    int n;\n    \n    vector<vector<string>> solveNQueens(int n) {\n        this->n = n;\n        this->board = vector<vector<int>>(n, vector<int>(n, 0));\n        solve(0);\n        return result;\n    }\n    \n    void solve(int row) {\n        if (row == n) {\n            result.push_back(buildBoard());\n            return;\n        }\n        \n        for (int col = 0; col < n; col++) {\n            if (isSafe(row, col)) {\n                board[row][col] = 1;\n                solve(row + 1);\n                board[row][col] = 0;  // backtrack\n            }\n        }\n    }\n    \n    bool isSafe(int row, int col) {\n        // check column, diagonals\n        return true;  // full logic in visualization\n    }\n\n    vector<string> buildBoard() {\n        vector<string> rows;\n        for (int i = 0; i < n; i++) {\n            string line(n, '.');\n            for (int j = 0; j < n; j++) if (board[i][j]) line[j] = 'Q';\n            rows.push_back(line);\n        }\n        return rows;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    32
   ]
  },
  "python": {
   "code": "class Solution:\n    def __init__(self):\n        self.result = []\n        self.board = None\n        self.n = 0\n\n    def solveNQueens(self, n):\n        self.n = n\n        self.board = [[0] * n for _ in range(n)]\n        self.solve(0)\n        return self.result\n\n    def solve(self, row):\n        if row == self.n:\n            self.result.append(self.buildBoard())\n            return\n\n        for col in range(self.n):\n            if self.isSafe(row, col):\n                self.board[row][col] = 1\n                self.solve(row + 1)\n                self.board[row][col] = 0  # backtrack\n\n    def isSafe(self, row, col):\n        # check column, diagonals\n        return True  # full logic in visualization\n\n    def buildBoard(self):\n        return [''.join('Q' if cell else '.' for cell in r) for r in self.board]",
   "map": [
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    12,
    13,
    14,
    15,
    16,
    18,
    19,
    20,
    21,
    22,
    23,
    27,
    28,
    29,
    30,
    null,
    null,
    null
   ]
  }
 },
 "kmp": {
  "c": {
   "code": "#include <stdlib.h>\n#include <string.h>\n\nstatic int* computeLPS(const char* pattern) {\n    int m = (int)strlen(pattern);\n    int* lps = (int*)calloc(m > 0 ? m : 1, sizeof(int));\n    int len = 0, i = 1;\n    while (i < m) {\n        if (pattern[i] == pattern[len]) {\n            len++;\n            lps[i] = len;\n            i++;\n        } else if (len > 0) {\n            len = lps[len - 1];\n        } else {\n            lps[i] = 0;\n            i++;\n        }\n    }\n    return lps;\n}\n\nint* kmp(const char* text, const char* pattern, int* returnSize) {\n    int* result = (int*)malloc(sizeof(int) * (strlen(text) + 1));\n    int count = 0;\n    int* lps = computeLPS(pattern);\n    int i = 0, j = 0, n = (int)strlen(text), m = (int)strlen(pattern);\n    \n    while (i < n) {\n        if (text[i] == pattern[j]) {\n            i++; j++;\n            if (j == m) {\n                result[count++] = i - j;\n                j = lps[j - 1];  // Continue searching\n            }\n        } else if (j > 0) {\n            j = lps[j - 1];  // Skip using LPS\n        } else {\n            i++;\n        }\n    }\n    \n    free(lps);\n    *returnSize = count;\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    21,
    21,
    22
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <string>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> kmp(const string& text, const string& pattern) {\n        vector<int> result;\n        vector<int> lps = computeLPS(pattern);\n        int i = 0, j = 0, n = (int)text.length(), m = (int)pattern.length();\n        \n        while (i < n) {\n            if (text[i] == pattern[j]) {\n                i++; j++;\n                if (j == m) {\n                    result.push_back(i - j);\n                    j = lps[j - 1];  // Continue searching\n                }\n            } else if (j > 0) {\n                j = lps[j - 1];  // Skip using LPS\n            } else {\n                i++;\n            }\n        }\n        \n        return result;\n    }\n\nprivate:\n    vector<int> computeLPS(const string& pattern) {\n        int m = (int)pattern.length();\n        vector<int> lps(m, 0);\n        int len = 0, i = 1;\n        while (i < m) {\n            if (pattern[i] == pattern[len]) {\n                len++;\n                lps[i] = len;\n                i++;\n            } else if (len > 0) {\n                len = lps[len - 1];\n            } else {\n                lps[i] = 0;\n                i++;\n            }\n        }\n        return lps;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    23
   ]
  },
  "python": {
   "code": "class Solution:\n    def kmp(self, text, pattern):\n        result = []\n        lps = self.computeLPS(pattern)\n        i, j, n, m = 0, 0, len(text), len(pattern)\n        \n        while i < n:\n            if text[i] == pattern[j]:\n                i += 1; j += 1\n                if j == m:\n                    result.append(i - j)\n                    j = lps[j - 1]  # Continue searching\n            elif j > 0:\n                j = lps[j - 1]  # Skip using LPS\n            else:\n                i += 1\n        \n        return result\n\n    def computeLPS(self, pattern):\n        m = len(pattern)\n        lps = [0] * m\n        length, i = 0, 1\n        while i < m:\n            if pattern[i] == pattern[length]:\n                length += 1\n                lps[i] = length\n                i += 1\n            elif length > 0:\n                length = lps[length - 1]\n            else:\n                lps[i] = 0\n                i += 1\n        return lps",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    14,
    15,
    16,
    17,
    20,
    21,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
   ]
  }
 },
 "knapsack": {
  "c": {
   "code": "#include <stdlib.h>\n\nstatic int max_int(int a, int b) {\n    return a > b ? a : b;\n}\n\nint knapsack(int* weights, int weightsSize, int* values, int capacity) {\n    int n = weightsSize;\n    int** dp = (int**)malloc((n + 1) * sizeof(int*));\n    for (int k = 0; k <= n; k++) {\n        dp[k] = (int*)calloc(capacity + 1, sizeof(int));\n    }\n    \n    for (int i = 1; i <= n; i++) {\n        int w = weights[i - 1];\n        int v = values[i - 1];\n        \n        for (int c = 0; c <= capacity; c++) {\n            if (w <= c) {\n                dp[i][c] = max_int(dp[i-1][c-w] + v, dp[i-1][c]);\n            } else {\n                dp[i][c] = dp[i-1][c];\n            }\n        }\n    }\n    \n    int result = dp[n][capacity];\n    for (int k = 0; k <= n; k++) {\n        free(dp[k]);\n    }\n    free(dp);\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    4,
    4,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    null,
    null,
    null,
    null,
    19,
    20
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <algorithm>\nusing namespace std;\n\nclass Solution {\npublic:\n    int knapsack(vector<int>& weights, vector<int>& values, int capacity) {\n        int n = weights.size();\n        vector<vector<int>> dp(n + 1, vector<int>(capacity + 1, 0));\n        \n        for (int i = 1; i <= n; i++) {\n            int w = weights[i - 1];\n            int v = values[i - 1];\n            \n            for (int c = 0; c <= capacity; c++) {\n                if (w <= c) {\n                    dp[i][c] = max(dp[i-1][c-w] + v, dp[i-1][c]);\n                } else {\n                    dp[i][c] = dp[i-1][c];\n                }\n            }\n        }\n        \n        return dp[n][capacity];\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21
   ]
  },
  "python": {
   "code": "from typing import List\n\nclass Solution:\n    def knapsack(self, weights: List[int], values: List[int], capacity: int) -> int:\n        n = len(weights)\n        dp = [[0] * (capacity + 1) for _ in range(n + 1)]\n        \n        for i in range(1, n + 1):\n            w = weights[i - 1]\n            v = values[i - 1]\n            \n            for c in range(0, capacity + 1):\n                if w <= c:\n                    dp[i][c] = max(dp[i-1][c-w] + v, dp[i-1][c])\n                else:\n                    dp[i][c] = dp[i-1][c]\n        \n        return dp[n][capacity]",
   "map": [
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    18,
    19
   ]
  }
 },
 "lcs": {
  "c": {
   "code": "#include <stdlib.h>\n#include <string.h>\n\nstatic inline int max(int a, int b) {\n    return a > b ? a : b;\n}\n\nint lcs(const char* s1, const char* s2) {\n    int m = (int)strlen(s1), n = (int)strlen(s2);\n    int (*dp)[n + 1] = calloc((size_t)(m + 1), sizeof *dp);\n    \n    for (int i = 1; i <= m; i++) {\n        for (int j = 1; j <= n; j++) {\n            if (s1[i - 1] == s2[j - 1]) {\n                dp[i][j] = dp[i - 1][j - 1] + 1;\n            } else {\n                dp[i][j] = max(dp[i - 1][j], dp[i][j - 1]);\n            }\n        }\n    }\n    \n    int result = dp[m][n];\n    free(dp);\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    16,
    16,
    17
   ]
  },
  "cpp": {
   "code": "#include <string>\n#include <vector>\n#include <algorithm>\n\nclass Solution {\npublic:\n    int lcs(const std::string& s1, const std::string& s2) {\n        int m = (int)s1.length(), n = (int)s2.length();\n        std::vector<std::vector<int>> dp(m + 1, std::vector<int>(n + 1, 0));\n        \n        for (int i = 1; i <= m; i++) {\n            for (int j = 1; j <= n; j++) {\n                if (s1[i - 1] == s2[j - 1]) {\n                    dp[i][j] = dp[i - 1][j - 1] + 1;\n                } else {\n                    dp[i][j] = std::max(dp[i - 1][j], dp[i][j - 1]);\n                }\n            }\n        }\n        \n        return dp[m][n];\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18
   ]
  },
  "python": {
   "code": "class Solution:\n    def lcs(self, s1, s2):\n        m, n = len(s1), len(s2)\n        dp = [[0] * (n + 1) for _ in range(m + 1)]\n\n        for i in range(1, m + 1):\n            for j in range(1, n + 1):\n                if s1[i - 1] == s2[j - 1]:\n                    dp[i][j] = dp[i - 1][j - 1] + 1\n                else:\n                    dp[i][j] = max(dp[i - 1][j], dp[i][j - 1])\n\n        return dp[m][n]",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    15,
    16
   ]
  }
 },
 "bfs": {
  "c": {
   "code": "#include <stdlib.h>\n\n/* adj[i] is the neighbor array of node i, adjSize[i] its length, n the number of nodes */\nint* bfs(int** adj, const int* adjSize, int n, int start, int* returnSize) {\n    int* result = (int*)malloc(n * sizeof(int));\n    *returnSize = 0;\n    char* visited = (char*)calloc(n, sizeof(char));\n    int cap = 1;\n    for (int i = 0; i < n; i++) cap += adjSize[i];\n    int* queue = (int*)malloc(cap * sizeof(int));\n    int head = 0, tail = 0;\n    queue[tail++] = start;\n    \n    while (head < tail) {\n        int node = queue[head++];\n        if (visited[node]) continue;\n        visited[node] = 1;\n        result[(*returnSize)++] = node;\n        \n        for (int i = 0; i < adjSize[node]; i++) {\n            int neighbor = adj[node][i];\n            if (!visited[neighbor]) {\n                queue[tail++] = neighbor;\n            }\n        }\n    }\n    \n    free(visited);\n    free(queue);\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    2,
    3,
    3,
    4,
    5,
    5,
    5,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    21,
    21,
    22
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <queue>\n#include <unordered_map>\n#include <unordered_set>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> bfs(unordered_map<int, vector<int>>& adj, int start) {\n        vector<int> result;\n        unordered_set<int> visited;\n        queue<int> queue;\n        queue.push(start);\n        \n        while (!queue.empty()) {\n            int node = queue.front();\n            queue.pop();\n            if (visited.count(node)) continue;\n            visited.insert(node);\n            result.push_back(node);\n            \n            for (int neighbor : adj.at(node)) {\n                if (!visited.count(neighbor)) {\n                    queue.push(neighbor);\n                }\n            }\n        }\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23
   ]
  },
  "python": {
   "code": "from collections import deque\nfrom typing import List, Dict\n\nclass Solution:\n    def bfs(self, adj: Dict[int, List[int]], start: int) -> List[int]:\n        result = []\n        visited = set()\n        queue = deque()\n        queue.append(start)\n        \n        while queue:\n            node = queue.popleft()\n            if node in visited:\n                continue\n            visited.add(node)\n            result.append(node)\n            \n            for neighbor in adj[node]:\n                if neighbor not in visited:\n                    queue.append(neighbor)\n        \n        return result",
   "map": [
    null,
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    20,
    21
   ]
  }
 },
 "tower-of-hanoi": {
  "c": {
   "code": "#include <stdio.h>\n\nint moveCount = 0;\n\nvoid hanoi(int n, char source, char target, char aux) {\n    if (n == 1) {\n        printf(\"Move disk 1 from %c to %c\\n\", source, target);\n        moveCount++;\n        return;\n    }\n    hanoi(n - 1, source, aux, target);\n    printf(\"Move disk %d from %c to %c\\n\", n, source, target);\n    moveCount++;\n    hanoi(n - 1, aux, target, source);\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14
   ]
  },
  "cpp": {
   "code": "#include <iostream>\n\nclass Solution {\npublic:\n    int moveCount = 0;\n\n    void hanoi(int n, char source, char target, char aux) {\n        if (n == 1) {\n            std::cout << \"Move disk 1 from \" << source << \" to \" << target << std::endl;\n            moveCount++;\n            return;\n        }\n        hanoi(n - 1, source, aux, target);\n        std::cout << \"Move disk \" << n << \" from \" << source << \" to \" << target << std::endl;\n        moveCount++;\n        hanoi(n - 1, aux, target, source);\n    }\n};",
   "map": [
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
   ]
  },
  "python": {
   "code": "class Solution:\n    def __init__(self):\n        self.moveCount = 0\n\n    def hanoi(self, n, source, target, aux):\n        if n == 1:\n            print(\"Move disk 1 from \" + source + \" to \" + target)\n            self.moveCount += 1\n            return\n        self.hanoi(n - 1, source, aux, target)\n        print(\"Move disk \" + str(n) + \" from \" + source + \" to \" + target)\n        self.moveCount += 1\n        self.hanoi(n - 1, aux, target, source)",
   "map": [
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    10,
    11,
    12,
    13
   ]
  }
 },
 "rabin-karp": {
  "c": {
   "code": "#include <stdlib.h>\n#include <string.h>\n\nstatic const int BASE = 31;\nstatic const int MOD = 101;\n\nint* rabinKarp(const char* text, const char* pattern, int* returnSize) {\n    int* result = (int*)malloc(sizeof(int) * (strlen(text) + 1));\n    *returnSize = 0;\n    int n = (int)strlen(text), m = (int)strlen(pattern);\n    if (m > n) return result;\n\n    long long patternHash = 0, windowHash = 0;\n    long long h = 1;\n    for (int i = 0; i < m - 1; i++) h = (h * BASE) % MOD;\n\n    for (int i = 0; i < m; i++) {\n        patternHash = (patternHash * BASE + (unsigned char)pattern[i]) % MOD;\n        windowHash  = (windowHash * BASE + (unsigned char)text[i]) % MOD;\n    }\n\n    for (int i = 0; i <= n - m; i++) {\n        if (windowHash == patternHash) {\n            if (strncmp(text + i, pattern, m) == 0) {\n                result[(*returnSize)++] = i;\n            }\n        }\n        if (i < n - m) {\n            windowHash = ((windowHash - (unsigned char)text[i] * h) * BASE + (unsigned char)text[i + m]) % MOD;\n            if (windowHash < 0) windowHash += MOD;\n        }\n    }\n\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    6,
    7,
    null,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31
   ]
  },
  "cpp": {
   "code": "#include <string>\n#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    static const int BASE = 31;\n    static const int MOD = 101;\n    \n    vector<int> rabinKarp(const string& text, const string& pattern) {\n        vector<int> result;\n        int n = (int)text.length(), m = (int)pattern.length();\n        if (m > n) return result;\n        \n        long long patternHash = 0, windowHash = 0;\n        long long h = 1;\n        for (int i = 0; i < m - 1; i++) h = (h * BASE) % MOD;\n        \n        for (int i = 0; i < m; i++) {\n            patternHash = (patternHash * BASE + (unsigned char)pattern[i]) % MOD;\n            windowHash  = (windowHash * BASE + (unsigned char)text[i]) % MOD;\n        }\n        \n        for (int i = 0; i <= n - m; i++) {\n            if (windowHash == patternHash) {\n                if (text.substr(i, m) == pattern) {\n                    result.push_back(i);\n                }\n            }\n            if (i < n - m) {\n                windowHash = ((windowHash - (unsigned char)text[i] * h) * BASE + (unsigned char)text[i + m]) % MOD;\n                if (windowHash < 0) windowHash += MOD;\n            }\n        }\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    null,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32
   ]
  },
  "python": {
   "code": "from typing import List\n\n\nclass Solution:\n    BASE = 31\n    MOD = 101\n\n    def rabinKarp(self, text: str, pattern: str) -> List[int]:\n        result = []\n        n, m = len(text), len(pattern)\n        if m > n:\n            return result\n\n        patternHash, windowHash = 0, 0\n        h = 1\n        for i in range(m - 1): h = (h * self.BASE) % self.MOD\n\n        for i in range(m):\n            patternHash = (patternHash * self.BASE + ord(pattern[i])) % self.MOD\n            windowHash  = (windowHash * self.BASE + ord(text[i])) % self.MOD\n\n        for i in range(n - m + 1):\n            if windowHash == patternHash:\n                if text[i:i + m] == pattern:\n                    result.append(i)\n            if i < n - m:\n                windowHash = ((windowHash - ord(text[i]) * h) * self.BASE + ord(text[i + m])) % self.MOD\n                if windowHash < 0: windowHash += self.MOD\n\n        return result",
   "map": [
    null,
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    null,
    null,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    17,
    18,
    19,
    20,
    21,
    24,
    25,
    26,
    29,
    30
   ]
  }
 },
 "permutations": {
  "c": {
   "code": "#include <stdio.h>\n#include <stdlib.h>\n\nint **result = NULL;\nint resultSize = 0;\nint resultCap = 0;\n\nvoid swap(int* a, int i, int j);\nvoid backtrack(int* nums, int numsSize, int start);\n\nint** permute(int* nums, int numsSize, int* returnSize) {\n    result = NULL; resultSize = 0; resultCap = 0;\n    backtrack(nums, numsSize, 0);\n    *returnSize = resultSize;\n    return result;\n}\n\nvoid backtrack(int* nums, int numsSize, int start) {\n    if (start == numsSize) {\n        int* perm = (int*)malloc(numsSize * sizeof(int));\n        for (int k = 0; k < numsSize; k++) { int n = nums[k]; perm[k] = n; }\n        if (resultSize == resultCap) {\n            resultCap = (resultCap == 0) ? 16 : resultCap * 2;\n            result = (int**)realloc(result, resultCap * sizeof(int*));\n        }\n        result[resultSize++] = perm;\n        return;\n    }\n    \n    for (int i = start; i < numsSize; i++) {\n        swap(nums, start, i);\n        backtrack(nums, numsSize, start + 1);\n        swap(nums, start, i);  // undo\n    }\n}\n\nvoid swap(int* a, int i, int j) {\n    int t = a[i]; a[i] = a[j]; a[j] = t;\n}",
   "map": [
    null,
    null,
    null,
    2,
    2,
    2,
    null,
    null,
    null,
    null,
    4,
    2,
    5,
    6,
    6,
    7,
    null,
    9,
    10,
    11,
    12,
    13,
    13,
    13,
    13,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    null,
    24,
    25,
    26
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<vector<int>> result;\n    \n    vector<vector<int>> permute(vector<int>& nums) {\n        backtrack(nums, 0);\n        return result;\n    }\n    \n    void backtrack(vector<int>& nums, int start) {\n        if (start == (int)nums.size()) {\n            vector<int> perm;\n            for (int n : nums) perm.push_back(n);\n            result.push_back(perm);\n            return;\n        }\n        \n        for (int i = start; i < (int)nums.size(); i++) {\n            swap(nums, start, i);\n            backtrack(nums, start + 1);\n            swap(nums, start, i);  // undo\n        }\n    }\n    \n    void swap(vector<int>& a, int i, int j) {\n        int t = a[i]; a[i] = a[j]; a[j] = t;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27
   ]
  },
  "python": {
   "code": "from typing import List\n\n\nclass Solution:\n    def __init__(self):\n        self.result = []\n    \n    def permute(self, nums: List[int]) -> List[List[int]]:\n        self.backtrack(nums, 0)\n        return self.result\n    \n    def backtrack(self, nums: List[int], start: int) -> None:\n        if start == len(nums):\n            perm = []\n            for n in nums: perm.append(n)\n            self.result.append(perm)\n            return\n        \n        for i in range(start, len(nums)):\n            self.swap(nums, start, i)\n            self.backtrack(nums, start + 1)\n            self.swap(nums, start, i)  # undo\n    \n    def swap(self, a: List[int], i: int, j: int) -> None:\n        t = a[i]; a[i] = a[j]; a[j] = t",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    16,
    17,
    18,
    19,
    20,
    23,
    24,
    25
   ]
  }
 },
 "product-except-self": {
  "c": {
   "code": "#include <stdlib.h>\n\nint* productExceptSelf(int* nums, int numsSize, int* returnSize) {\n    int n = numsSize;\n    int* result = (int*)malloc(n * sizeof(int));\n    *returnSize = n;\n    \n    // Build prefix products\n    result[0] = 1;\n    for (int i = 1; i < n; i++) {\n        result[i] = result[i - 1] * nums[i - 1];\n    }\n    \n    // Build suffix products and multiply\n    int suffix = 1;\n    for (int i = n - 1; i >= 0; i--) {\n        result[i] = result[i] * suffix;\n        suffix *= nums[i];\n    }\n    \n    return result;\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> productExceptSelf(vector<int>& nums) {\n        int n = nums.size();\n        vector<int> result(n);\n        \n        // Build prefix products\n        result[0] = 1;\n        for (int i = 1; i < n; i++) {\n            result[i] = result[i - 1] * nums[i - 1];\n        }\n        \n        // Build suffix products and multiply\n        int suffix = 1;\n        for (int i = n - 1; i >= 0; i--) {\n            result[i] = result[i] * suffix;\n            suffix *= nums[i];\n        }\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21
   ]
  },
  "python": {
   "code": "class Solution:\n    def productExceptSelf(self, nums):\n        n = len(nums)\n        result = [0] * n\n        \n        # Build prefix products\n        result[0] = 1\n        for i in range(1, n):\n            result[i] = result[i - 1] * nums[i - 1]\n        \n        # Build suffix products and multiply\n        suffix = 1\n        for i in range(n - 1, -1, -1):\n            result[i] = result[i] * suffix\n            suffix *= nums[i]\n        \n        return result",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    11,
    12,
    13,
    14,
    15,
    16,
    18,
    19
   ]
  }
 },
 "lca": {
  "c": {
   "code": "#include <stddef.h>\n\ntypedef struct TreeNode {\n    int val;\n    struct TreeNode *left;\n    struct TreeNode *right;\n} TreeNode;\n\nTreeNode* lca(TreeNode* root, TreeNode* p, TreeNode* q) {\n    // Base case\n    if (root == NULL) return NULL;\n    if (root == p || root == q) return root;\n    \n    // Search both subtrees\n    TreeNode* left = lca(root->left, p, q);\n    TreeNode* right = lca(root->right, p, q);\n    \n    // p and q on different sides — current is LCA\n    if (left != NULL && right != NULL) return root;\n    \n    // Otherwise pass up whichever side found something\n    return left != NULL ? left : right;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16
   ]
  },
  "cpp": {
   "code": "#include <cstddef>\n\nstruct TreeNode {\n    int val;\n    TreeNode* left;\n    TreeNode* right;\n};\n\nclass Solution {\npublic:\n    TreeNode* lca(TreeNode* root, TreeNode* p, TreeNode* q) {\n        // Base case\n        if (root == nullptr) return nullptr;\n        if (root == p || root == q) return root;\n        \n        // Search both subtrees\n        TreeNode* left = lca(root->left, p, q);\n        TreeNode* right = lca(root->right, p, q);\n        \n        // p and q on different sides — current is LCA\n        if (left != nullptr && right != nullptr) return root;\n        \n        // Otherwise pass up whichever side found something\n        return left != nullptr ? left : right;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17
   ]
  },
  "python": {
   "code": "class Solution:\n    def lca(self, root, p, q):\n        # Base case\n        if root is None: return None\n        if root is p or root is q: return root\n        \n        # Search both subtrees\n        left = self.lca(root.left, p, q)\n        right = self.lca(root.right, p, q)\n        \n        # p and q on different sides — current is LCA\n        if left is not None and right is not None: return root\n        \n        # Otherwise pass up whichever side found something\n        return left if left is not None else right",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
   ]
  }
 },
 "find-peak-element": {
  "c": {
   "code": "#include <stddef.h>\n\nint findPeakElement(int* nums, int numsSize) {\n    int left = 0;\n    int right = numsSize - 1;\n    \n    while (left < right) {\n        int mid = left + (right - left) / 2;\n        \n        if (nums[mid] < nums[mid + 1]) {\n            // Peak is on the right side\n            left = mid + 1;\n        } else {\n            // Peak is at mid or on the left side\n            right = mid;\n        }\n    }\n    \n    return left;\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    int findPeakElement(vector<int>& nums) {\n        int left = 0;\n        int right = nums.size() - 1;\n        \n        while (left < right) {\n            int mid = left + (right - left) / 2;\n            \n            if (nums[mid] < nums[mid + 1]) {\n                // Peak is on the right side\n                left = mid + 1;\n            } else {\n                // Peak is at mid or on the left side\n                right = mid;\n            }\n        }\n        \n        return left;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
   ]
  },
  "python": {
   "code": "class Solution:\n    def findPeakElement(self, nums):\n        left = 0\n        right = len(nums) - 1\n        \n        while left < right:\n            mid = left + (right - left) // 2\n            \n            if nums[mid] < nums[mid + 1]:\n                # Peak is on the right side\n                left = mid + 1\n            else:\n                # Peak is at mid or on the left side\n                right = mid\n        \n        return left",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    16,
    18
   ]
  }
 },
 "inorder-traversal": {
  "c": {
   "code": "#include <stdlib.h>\n\nstruct TreeNode {\n    int val;\n    struct TreeNode *left;\n    struct TreeNode *right;\n};\n\n/* class Solution */\nint *result = NULL;\nint resultSize = 0;\nint resultCap = 0;\n\nint* inorder(struct TreeNode* root) {\n    if (root == NULL) return result;\n    \n    inorder(root->left);   // Left\n    if (resultSize == resultCap) {\n        resultCap = (resultCap == 0) ? 8 : resultCap * 2;\n        result = (int*)realloc(result, resultCap * sizeof(int));\n    }\n    result[resultSize++] = root->val; // Root\n    inorder(root->right);  // Right\n    \n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    2,
    2,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    8,
    8,
    8,
    8,
    9,
    10,
    11,
    12
   ]
  },
  "cpp": {
   "code": "#include <vector>\n\nstruct TreeNode {\n    int val;\n    TreeNode *left;\n    TreeNode *right;\n};\n\nclass Solution {\npublic:\n    std::vector<int> result;\n    \n    std::vector<int>& inorder(TreeNode* root) {\n        if (root == nullptr) return result;\n        \n        inorder(root->left);   // Left\n        result.push_back(root->val); // Root\n        inorder(root->right);  // Right\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13
   ]
  },
  "python": {
   "code": "from typing import List\n\nclass TreeNode:\n    def __init__(self, val=0, left=None, right=None):\n        self.val = val\n        self.left = left\n        self.right = right\n\nclass Solution:\n    def __init__(self):\n        self.result = []\n    \n    def inorder(self, root) -> List[int]:\n        if root is None: return self.result\n        \n        self.inorder(root.left)   # Left\n        self.result.append(root.val) # Root\n        self.inorder(root.right)  # Right\n        \n        return self.result",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    2,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11
   ]
  }
 },
 "search-rotated": {
  "c": {
   "code": "#include <stddef.h>\n\nint search(int* nums, int numsSize, int target) {\n    int left = 0;\n    int right = numsSize - 1;\n    \n    while (left <= right) {\n        int mid = left + (right - left) / 2;\n        \n        if (nums[mid] == target) {\n            return mid;\n        }\n        \n        // Left half is sorted\n        if (nums[left] <= nums[mid]) {\n            if (target >= nums[left] && target < nums[mid]) {\n                right = mid - 1;\n            } else {\n                left = mid + 1;\n            }\n        } else {\n            // Right half is sorted\n            if (target > nums[mid] && target <= nums[right]) {\n                left = mid + 1;\n            } else {\n                right = mid - 1;\n            }\n        }\n    }\n    \n    return -1;\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    int search(vector<int>& nums, int target) {\n        int left = 0;\n        int right = (int)nums.size() - 1;\n        \n        while (left <= right) {\n            int mid = left + (right - left) / 2;\n            \n            if (nums[mid] == target) {\n                return mid;\n            }\n            \n            // Left half is sorted\n            if (nums[left] <= nums[mid]) {\n                if (target >= nums[left] && target < nums[mid]) {\n                    right = mid - 1;\n                } else {\n                    left = mid + 1;\n                }\n            } else {\n                // Right half is sorted\n                if (target > nums[mid] && target <= nums[right]) {\n                    left = mid + 1;\n                } else {\n                    right = mid - 1;\n                }\n            }\n        }\n        \n        return -1;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32
   ]
  },
  "python": {
   "code": "from typing import List\n\nclass Solution:\n    def search(self, nums: List[int], target: int) -> int:\n        left = 0\n        right = len(nums) - 1\n        \n        while left <= right:\n            mid = left + (right - left) // 2\n            \n            if nums[mid] == target:\n                return mid\n            \n            # Left half is sorted\n            if nums[left] <= nums[mid]:\n                if target >= nums[left] and target < nums[mid]:\n                    right = mid - 1\n                else:\n                    left = mid + 1\n            else:\n                # Right half is sorted\n                if target > nums[mid] and target <= nums[right]:\n                    left = mid + 1\n                else:\n                    right = mid - 1\n        \n        return -1",
   "map": [
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    20,
    21,
    22,
    23,
    24,
    25,
    29,
    30
   ]
  }
 },
 "linear-search": {
  "c": {
   "code": "#include <stddef.h>\n\nint linearSearch(int* array, int arrayLength, int target) {\n    // Iterate through the array\n    for (int i = 0; i < arrayLength; i++) {\n        // Check if current element matches target\n        if (array[i] == target) {\n            return i; // Found at index i\n        }\n    }\n    return -1; // Not found\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11
   ]
  },
  "cpp": {
   "code": "#include <vector>\n\nclass Solution {\npublic:\n    int linearSearch(const std::vector<int>& array, int target) {\n        // Iterate through the array\n        for (int i = 0; i < (int)array.size(); i++) {\n            // Check if current element matches target\n            if (array[i] == target) {\n                return i; // Found at index i\n            }\n        }\n        return -1; // Not found\n    }\n};",
   "map": [
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
   ]
  },
  "python": {
   "code": "class Solution:\n    def linearSearch(self, array, target):\n        # Iterate through the array\n        for i in range(len(array)):\n            # Check if current element matches target\n            if array[i] == target:\n                return i  # Found at index i\n        return -1  # Not found",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    10
   ]
  }
 },
 "trapping-rain-water": {
  "c": {
   "code": "#include <stddef.h>\n\nint trap(int* height, int heightSize) {\n    int left = 0, right = heightSize - 1;\n    int leftMax = 0, rightMax = 0;\n    int water = 0;\n    \n    while (left < right) {\n        if (height[left] < height[right]) {\n            if (height[left] >= leftMax) {\n                leftMax = height[left];\n            } else {\n                water += leftMax - height[left];\n            }\n            left++;\n        } else {\n            if (height[right] >= rightMax) {\n                rightMax = height[right];\n            } else {\n                water += rightMax - height[right];\n            }\n            right--;\n        }\n    }\n    \n    return water;\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    int trap(vector<int>& height) {\n        int left = 0, right = (int)height.size() - 1;\n        int leftMax = 0, rightMax = 0;\n        int water = 0;\n        \n        while (left < right) {\n            if (height[left] < height[right]) {\n                if (height[left] >= leftMax) {\n                    leftMax = height[left];\n                } else {\n                    water += leftMax - height[left];\n                }\n                left++;\n            } else {\n                if (height[right] >= rightMax) {\n                    rightMax = height[right];\n                } else {\n                    water += rightMax - height[right];\n                }\n                right--;\n            }\n        }\n        \n        return water;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27
   ]
  },
  "python": {
   "code": "class Solution:\n    def trap(self, height):\n        left, right = 0, len(height) - 1\n        leftMax, rightMax = 0, 0\n        water = 0\n        \n        while left < right:\n            if height[left] < height[right]:\n                if height[left] >= leftMax:\n                    leftMax = height[left]\n                else:\n                    water += leftMax - height[left]\n                left += 1\n            else:\n                if height[right] >= rightMax:\n                    rightMax = height[right]\n                else:\n                    water += rightMax - height[right]\n                right -= 1\n        \n        return water",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    14,
    15,
    16,
    17,
    18,
    19,
    21,
    24,
    25
   ]
  }
 },
 "level-order-traversal": {
  "c": {
   "code": "#include <stdlib.h>\n\ntypedef struct TreeNode {\n    int val;\n    struct TreeNode* left;\n    struct TreeNode* right;\n} TreeNode;\n\nint* levelOrder(TreeNode* root, int* returnSize) {\n    int capacity = 16;\n    int* result = (int*)malloc(capacity * sizeof(int));\n    *returnSize = 0;\n    if (root == NULL) return result;\n\n    int queueCap = 16;\n    int head = 0, tail = 0;\n    TreeNode** queue = (TreeNode**)malloc(queueCap * sizeof(TreeNode*));\n    queue[tail++] = root;\n\n    while (head < tail) {\n        TreeNode* node = queue[head++];\n        if (*returnSize == capacity) {\n            capacity *= 2;\n            result = (int*)realloc(result, capacity * sizeof(int));\n        }\n        result[(*returnSize)++] = node->val;\n\n        if (node->left != NULL) {\n            if (tail == queueCap) {\n                queueCap *= 2;\n                queue = (TreeNode**)realloc(queue, queueCap * sizeof(TreeNode*));\n            }\n            queue[tail++] = node->left;\n        }\n        if (node->right != NULL) {\n            if (tail == queueCap) {\n                queueCap *= 2;\n                queue = (TreeNode**)realloc(queue, queueCap * sizeof(TreeNode*));\n            }\n            queue[tail++] = node->right;\n        }\n    }\n\n    free(queue);\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    3,
    3,
    4,
    null,
    6,
    6,
    6,
    7,
    null,
    9,
    10,
    11,
    11,
    11,
    11,
    11,
    null,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    15,
    null,
    17,
    17,
    18
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <queue>\nusing namespace std;\n\nstruct TreeNode {\n    int val;\n    TreeNode* left;\n    TreeNode* right;\n    TreeNode(int x) : val(x), left(nullptr), right(nullptr) {}\n};\n\nclass Solution {\npublic:\n    vector<int> levelOrder(TreeNode* root) {\n        vector<int> result;\n        if (root == nullptr) return result;\n        \n        queue<TreeNode*> queue;\n        queue.push(root);\n        \n        while (!queue.empty()) {\n            TreeNode* node = queue.front();\n            queue.pop();\n            result.push_back(node->val);\n            \n            if (node->left != nullptr) queue.push(node->left);\n            if (node->right != nullptr) queue.push(node->right);\n        }\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19
   ]
  },
  "python": {
   "code": "from typing import List, Optional\nfrom collections import deque\n\nclass Solution:\n    def levelOrder(self, root: Optional['TreeNode']) -> List[int]:\n        result = []\n        if root is None: return result\n        \n        queue = deque()\n        queue.append(root)\n        \n        while queue:\n            node = queue.popleft()\n            result.append(node.val)\n            \n            if node.left is not None: queue.append(node.left)\n            if node.right is not None: queue.append(node.right)\n        \n        return result",
   "map": [
    null,
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    16,
    17
   ]
  }
 },
 "bubble-sort": {
  "c": {
   "code": "#include <stdbool.h>\n#include <stddef.h>\n\nint* bubbleSort(int* nums, int numsSize) {\n    int n = numsSize;\n    \n    for (int i = 0; i < n - 1; i++) {\n        bool swapped = false;\n        \n        for (int j = 0; j < n - i - 1; j++) {\n            if (nums[j] > nums[j + 1]) {\n                // Swap adjacent elements\n                int temp = nums[j];\n                nums[j] = nums[j + 1];\n                nums[j + 1] = temp;\n                swapped = true;\n            }\n        }\n        \n        // Early exit if already sorted\n        if (!swapped) break;\n    }\n    \n    return nums;\n}",
   "map": [
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> bubbleSort(vector<int> nums) {\n        int n = nums.size();\n        \n        for (int i = 0; i < n - 1; i++) {\n            bool swapped = false;\n            \n            for (int j = 0; j < n - i - 1; j++) {\n                if (nums[j] > nums[j + 1]) {\n                    // Swap adjacent elements\n                    int temp = nums[j];\n                    nums[j] = nums[j + 1];\n                    nums[j + 1] = temp;\n                    swapped = true;\n                }\n            }\n            \n            // Early exit if already sorted\n            if (!swapped) break;\n        }\n        \n        return nums;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24
   ]
  },
  "python": {
   "code": "class Solution:\n    def bubbleSort(self, nums):\n        n = len(nums)\n        \n        for i in range(n - 1):\n            swapped = False\n            \n            for j in range(n - i - 1):\n                if nums[j] > nums[j + 1]:\n                    # Swap adjacent elements\n                    temp = nums[j]\n                    nums[j] = nums[j + 1]\n                    nums[j + 1] = temp\n                    swapped = True\n            \n            # Early exit if already sorted\n            if not swapped:\n                break\n        \n        return nums",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    17,
    18,
    19,
    19,
    21,
    22
   ]
  }
 },
 "binary-search": {
  "c": {
   "code": "int binarySearch(int* nums, int numsSize, int target) {\n    int left = 0;\n    int right = numsSize - 1;\n    \n    while (left <= right) {\n        int mid = left + (right - left) / 2;\n        \n        if (nums[mid] == target) {\n            return mid;\n        } else if (nums[mid] < target) {\n            left = mid + 1;\n        } else {\n            right = mid - 1;\n        }\n    }\n    \n    return -1;\n}",
   "map": [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19
   ]
  },
  "cpp": {
   "code": "#include <vector>\n\nclass Solution {\npublic:\n    int binarySearch(std::vector<int>& nums, int target) {\n        int left = 0;\n        int right = (int)nums.size() - 1;\n        \n        while (left <= right) {\n            int mid = left + (right - left) / 2;\n            \n            if (nums[mid] == target) {\n                return mid;\n            } else if (nums[mid] < target) {\n                left = mid + 1;\n            } else {\n                right = mid - 1;\n            }\n        }\n        \n        return -1;\n    }\n};",
   "map": [
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
   ]
  },
  "python": {
   "code": "class Solution:\n    def binarySearch(self, nums, target):\n        left = 0\n        right = len(nums) - 1\n        \n        while left <= right:\n            mid = left + (right - left) // 2\n            \n            if nums[mid] == target:\n                return mid\n            elif nums[mid] < target:\n                left = mid + 1\n            else:\n                right = mid - 1\n        \n        return -1",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    17,
    18
   ]
  }
 },
 "remove-duplicates": {
  "c": {
   "code": "#include <stddef.h>\n\nint removeDuplicates(int* nums, int numsSize) {\n    if (numsSize == 0) return 0;\n    \n    int slow = 0;\n    \n    for (int fast = 1; fast < numsSize; fast++) {\n        if (nums[fast] != nums[slow]) {\n            slow++;\n            nums[slow] = nums[fast];\n        }\n    }\n    \n    return slow + 1;\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
   ]
  },
  "cpp": {
   "code": "#include <vector>\n\nclass Solution {\npublic:\n    int removeDuplicates(std::vector<int>& nums) {\n        if (nums.size() == 0) return 0;\n        \n        int slow = 0;\n        \n        for (int fast = 1; fast < (int)nums.size(); fast++) {\n            if (nums[fast] != nums[slow]) {\n                slow++;\n                nums[slow] = nums[fast];\n            }\n        }\n        \n        return slow + 1;\n    }\n};",
   "map": [
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16
   ]
  },
  "python": {
   "code": "class Solution:\n    def removeDuplicates(self, nums):\n        if len(nums) == 0: return 0\n        \n        slow = 0\n        \n        for fast in range(1, len(nums)):\n            if nums[fast] != nums[slow]:\n                slow += 1\n                nums[slow] = nums[fast]\n        \n        return slow + 1",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    13,
    14
   ]
  }
 },
 "container-with-most-water": {
  "c": {
   "code": "#include <stdlib.h>\n\nstatic int min(int a, int b) { return a < b ? a : b; }\nstatic int max(int a, int b) { return a > b ? a : b; }\n\nint maxArea(int* height, int heightSize) {\n    int left = 0;\n    int right = heightSize - 1;\n    int maxArea = 0;\n    \n    while (left < right) {\n        int width = right - left;\n        int h = min(height[left], height[right]);\n        int area = width * h;\n        maxArea = max(maxArea, area);\n        \n        if (height[left] < height[right]) {\n            left++;\n        } else {\n            right--;\n        }\n    }\n    \n    return maxArea;\n}",
   "map": [
    null,
    null,
    null,
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <algorithm>\nusing namespace std;\n\nclass Solution {\npublic:\n    int maxArea(vector<int>& height) {\n        int left = 0;\n        int right = (int)height.size() - 1;\n        int maxArea = 0;\n        \n        while (left < right) {\n            int width = right - left;\n            int h = min(height[left], height[right]);\n            int area = width * h;\n            maxArea = max(maxArea, area);\n            \n            if (height[left] < height[right]) {\n                left++;\n            } else {\n                right--;\n            }\n        }\n        \n        return maxArea;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22
   ]
  },
  "python": {
   "code": "from typing import List\n\nclass Solution:\n    def maxArea(self, height: List[int]) -> int:\n        left = 0\n        right = len(height) - 1\n        maxArea = 0\n        \n        while left < right:\n            width = right - left\n            h = min(height[left], height[right])\n            area = width * h\n            maxArea = max(maxArea, area)\n            \n            if height[left] < height[right]:\n                left += 1\n            else:\n                right -= 1\n        \n        return maxArea",
   "map": [
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    19,
    20
   ]
  }
 },
 "subsets": {
  "c": {
   "code": "#include <stdlib.h>\n#include <string.h>\n\nstatic int **result = NULL;\nstatic int *resultColSizes = NULL;\nstatic int resultSize = 0;\nstatic int resultCapacity = 0;\n\nvoid backtrack(int *nums, int numsSize, int start, int *current, int *currentSize);\n\nint **subsets(int *nums, int numsSize, int *returnSize, int **returnColumnSizes) {\n    result = NULL;\n    resultColSizes = NULL;\n    resultSize = 0;\n    resultCapacity = 0;\n    int *current = (int *)malloc(sizeof(int) * (numsSize > 0 ? numsSize : 1));\n    int currentSize = 0;\n    backtrack(nums, numsSize, 0, current, &currentSize);\n    free(current);\n    *returnSize = resultSize;\n    *returnColumnSizes = resultColSizes;\n    return result;\n}\n\nvoid backtrack(int *nums, int numsSize, int start, int *current, int *currentSize) {\n    /* result.add(new ArrayList<>(current)); */\n    if (resultSize == resultCapacity) {\n        resultCapacity = resultCapacity == 0 ? 16 : resultCapacity * 2;\n        result = (int **)realloc(result, sizeof(int *) * resultCapacity);\n        resultColSizes = (int *)realloc(resultColSizes, sizeof(int) * resultCapacity);\n    }\n    result[resultSize] = (int *)malloc(sizeof(int) * (*currentSize > 0 ? *currentSize : 1));\n    memcpy(result[resultSize], current, sizeof(int) * (*currentSize));\n    resultColSizes[resultSize] = *currentSize;\n    resultSize++;\n\n    for (int i = start; i < numsSize; i++) {\n        current[(*currentSize)++] = nums[i];\n        backtrack(nums, numsSize, i + 1, current, currentSize);\n        (*currentSize)--;\n    }\n}",
   "map": [
    null,
    null,
    null,
    2,
    2,
    2,
    2,
    null,
    null,
    null,
    4,
    2,
    2,
    2,
    2,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    7,
    null,
    9,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<vector<int>> result;\n    \n    vector<vector<int>> subsets(vector<int>& nums) {\n        vector<int> current;\n        backtrack(nums, 0, current);\n        return result;\n    }\n    \n    void backtrack(vector<int>& nums, int start, vector<int>& current) {\n        result.push_back(current);\n        \n        for (int i = start; i < (int)nums.size(); i++) {\n            current.push_back(nums[i]);\n            backtrack(nums, i + 1, current);\n            current.pop_back();\n        }\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18
   ]
  },
  "python": {
   "code": "from typing import List\n\nclass Solution:\n    def __init__(self):\n        self.result = []\n    \n    def subsets(self, nums: List[int]) -> List[List[int]]:\n        self.backtrack(nums, 0, [])\n        return self.result\n    \n    def backtrack(self, nums: List[int], start: int, current: List[int]) -> None:\n        self.result.append(current[:])\n        \n        for i in range(start, len(nums)):\n            current.append(nums[i])\n            self.backtrack(nums, i + 1, current)\n            current.pop()",
   "map": [
    null,
    null,
    1,
    2,
    2,
    3,
    4,
    5,
    6,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
   ]
  }
 },
 "dfs": {
  "c": {
   "code": "#include <stdio.h>\n#include <stdlib.h>\n#include <stdbool.h>\n\n/* adj[node] is an array of neighbors, adjSizes[node] its length; nodes are 0..n-1 */\nint* dfs(int** adj, const int* adjSizes, int n, int start, int* returnSize) {\n    int cap = 1;\n    for (int k = 0; k < n; k++) cap += adjSizes[k];\n    int* result = (int*)malloc(n * sizeof(int));\n    int resultSize = 0;\n    bool* visited = (bool*)calloc(n, sizeof(bool));\n    int* stack = (int*)malloc(cap * sizeof(int));\n    int top = 0;\n    stack[top++] = start;\n    \n    while (top > 0) {\n        int node = stack[--top];\n        if (visited[node]) continue;\n        visited[node] = true;\n        result[resultSize++] = node;\n        \n        int* neighbors = adj[node];\n        int neighborsSize = adjSizes[node];\n        for (int i = neighborsSize - 1; i >= 0; i--) {\n            int neighbor = neighbors[i];\n            if (!visited[neighbor]) {\n                stack[top++] = neighbor;\n            }\n        }\n    }\n    \n    free(visited);\n    free(stack);\n    *returnSize = resultSize;\n    return result;\n}",
   "map": [
    null,
    null,
    null,
    null,
    2,
    2,
    5,
    5,
    3,
    3,
    4,
    5,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    23,
    23,
    23,
    24
   ]
  },
  "cpp": {
   "code": "#include <vector>\n#include <unordered_map>\n#include <unordered_set>\n#include <stack>\nusing namespace std;\n\nclass Solution {\npublic:\n    vector<int> dfs(unordered_map<int, vector<int>>& adj, int start) {\n        vector<int> result;\n        unordered_set<int> visited;\n        stack<int> stack;\n        stack.push(start);\n        \n        while (!stack.empty()) {\n            int node = stack.top();\n            stack.pop();\n            if (visited.count(node)) continue;\n            visited.insert(node);\n            result.push_back(node);\n            \n            vector<int>& neighbors = adj[node];\n            for (int i = (int)neighbors.size() - 1; i >= 0; i--) {\n                int neighbor = neighbors[i];\n                if (!visited.count(neighbor)) {\n                    stack.push(neighbor);\n                }\n            }\n        }\n        \n        return result;\n    }\n};",
   "map": [
    null,
    null,
    null,
    null,
    null,
    null,
    1,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25
   ]
  },
  "python": {
   "code": "from typing import Dict, List\n\nclass Solution:\n    def dfs(self, adj: Dict[int, List[int]], start: int) -> List[int]:\n        result = []\n        visited = set()\n        stack = []\n        stack.append(start)\n        \n        while len(stack) > 0:\n            node = stack.pop()\n            if node in visited:\n                continue\n            visited.add(node)\n            result.append(node)\n            \n            neighbors = adj[node]\n            for i in range(len(neighbors) - 1, -1, -1):\n                neighbor = neighbors[i]\n                if neighbor not in visited:\n                    stack.append(neighbor)\n        \n        return result",
   "map": [
    null,
    null,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    22,
    23
   ]
  }
 },
 "fibonacci": {
  "c": {
   "code": "#include <stdio.h>\n\nint fibonacci(int n) {\n    // Base cases\n    if (n <= 1) return n;\n    // Recursive case\n    return fibonacci(n - 1) + fibonacci(n - 2);\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7
   ]
  },
  "cpp": {
   "code": "#include <iostream>\n\nclass Solution {\npublic:\n    int fibonacci(int n) {\n        // Base cases\n        if (n <= 1) return n;\n        // Recursive case\n        return fibonacci(n - 1) + fibonacci(n - 2);\n    }\n};",
   "map": [
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8
   ]
  },
  "python": {
   "code": "class Solution:\n    def fibonacci(self, n):\n        # Base cases\n        if n <= 1:\n            return n\n        # Recursive case\n        return self.fibonacci(n - 1) + self.fibonacci(n - 2)",
   "map": [
    1,
    2,
    3,
    4,
    4,
    5,
    6
   ]
  }
 },
 "first-missing-positive": {
  "c": {
   "code": "int firstMissingPositive(int* nums, int numsSize) {\n    int n = numsSize;\n    \n    // Place each number in its right position\n    for (int i = 0; i < n; i++) {\n        while (nums[i] > 0 && nums[i] <= n && \n               nums[nums[i] - 1] != nums[i]) {\n            // Swap nums[i] to its correct position\n            int temp = nums[nums[i] - 1];\n            nums[nums[i] - 1] = nums[i];\n            nums[i] = temp;\n        }\n    }\n    \n    // Find first missing positive\n    for (int i = 0; i < n; i++) {\n        if (nums[i] != i + 1) {\n            return i + 1;\n        }\n    }\n    \n    return n + 1;\n}",
   "map": [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24
   ]
  },
  "cpp": {
   "code": "#include <vector>\nusing namespace std;\n\nclass Solution {\npublic:\n    int firstMissingPositive(vector<int>& nums) {\n        int n = (int)nums.size();\n        \n        // Place each number in its right position\n        for (int i = 0; i < n; i++) {\n            while (nums[i] > 0 && nums[i] <= n && \n                   nums[nums[i] - 1] != nums[i]) {\n                // Swap nums[i] to its correct position\n                int temp = nums[nums[i] - 1];\n                nums[nums[i] - 1] = nums[i];\n                nums[i] = temp;\n            }\n        }\n        \n        // Find first missing positive\n        for (int i = 0; i < n; i++) {\n            if (nums[i] != i + 1) {\n                return i + 1;\n            }\n        }\n        \n        return n + 1;\n    }\n};",
   "map": [
    null,
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25
   ]
  },
  "python": {
   "code": "class Solution:\n    def firstMissingPositive(self, nums):\n        n = len(nums)\n        \n        # Place each number in its right position\n        for i in range(n):\n            while (nums[i] > 0 and nums[i] <= n and\n                   nums[nums[i] - 1] != nums[i]):\n                # Swap nums[i] to its correct position\n                temp = nums[nums[i] - 1]\n                nums[nums[i] - 1] = nums[i]\n                nums[i] = temp\n        \n        # Find first missing positive\n        for i in range(n):\n            if nums[i] != i + 1:\n                return i + 1\n        \n        return n + 1",
   "map": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    15,
    16,
    17,
    18,
    19,
    22,
    23
   ]
  }
 },
 "factorial": {
  "c": {
   "code": "int factorial(int n) {\n    // Base case\n    if (n <= 1) {\n        return 1;\n    }\n    // Recursive case\n    return n * factorial(n - 1);\n}",
   "map": [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9
   ]
  },
  "cpp": {
   "code": "class Solution {\npublic:\n    int factorial(int n) {\n        // Base case\n        if (n <= 1) {\n            return 1;\n        }\n        // Recursive case\n        return n * factorial(n - 1);\n    }\n};",
   "map": [
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
   ]
  },
  "python": {
   "code": "class Solution:\n    def factorial(self, n):\n        # Base case\n        if n <= 1:\n            return 1\n        # Recursive case\n        return n * self.factorial(n - 1)",
   "map": [
    1,
    2,
    3,
    4,
    5,
    7,
    8
   ]
  }
 },
 "fibonacci-memo": {
  "c": {
   "code": "#include <stdlib.h>\n\nint fibonacci(int n) {\n    if (n <= 1) return n;\n    int* dp = (int*)malloc((n + 1) * sizeof(int));\n    dp[0] = 0; dp[1] = 1;\n    \n    for (int i = 2; i <= n; i++) {\n        dp[i] = dp[i - 1] + dp[i - 2];\n    }\n    \n    int result = dp[n];\n    free(dp);\n    return result;\n}",
   "map": [
    null,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    11,
    11,
    12
   ]
  },
  "cpp": {
   "code": "#include <vector>\n\nclass Solution {\npublic:\n    int fibonacci(int n) {\n        if (n <= 1) return n;\n        std::vector<int> dp(n + 1);\n        dp[0] = 0; dp[1] = 1;\n        \n        for (int i = 2; i <= n; i++) {\n            dp[i] = dp[i - 1] + dp[i - 2];\n        }\n        \n        return dp[n];\n    }\n};",
   "map": [
    null,
    null,
    1,
    null,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13
   ]
  },
  "python": {
   "code": "class Solution:\n    def fibonacci(self, n):\n        if n <= 1:\n            return n\n        dp = [0] * (n + 1)\n        dp[0] = 0; dp[1] = 1\n        \n        for i in range(2, n + 1):\n            dp[i] = dp[i - 1] + dp[i - 2]\n        \n        return dp[n]",
   "map": [
    1,
    2,
    3,
    3,
    4,
    5,
    6,
    7,
    8,
    10,
    11
   ]
  }
 }
};
